'use strict';

/* globals window */

var React = require('react');

var Header = require('./common-parts/header.jsx');
var Video = require('./common-parts/video.jsx');
var Share = require('./common-parts/share.jsx');
var Aggregator = require('./common-parts/aggregator.jsx');
var PictureChooser = require('./common-parts/picturechooser');
var at = require('../utils/environment');
var newPlayerInstance = require('../utils/lazy-video');


var PostVideo = React.createClass({
    componentDidMount: function() {
        newPlayerInstance(this.refs.title);
    },

    createShareUrl: function() {
        var content = this.props.content;
        var videoId = content.video.id;
        var origin = '';
        var pathname = '';

        if (at.client) {
            origin = window.location.origin;
            pathname = window.location.pathname;
        }

        return [origin, pathname, '#v/', videoId].join('');
    },

    callRecommendation: function() {
        var tag = this.props.content.tag;
        if (tag && window.convertRecAb)
            window.convertRecAb(tag);
    },

    render: function() {
        var content = this.props.content;
        var aggregator;
        var aggregates = this.props.aggregatedPosts;

        content.url = this.createShareUrl();

        if (aggregates && aggregates.length > 0) aggregator = <Aggregator items={aggregates} />;
        else aggregator = null;

        return (
            <div className='feed-post' data-post-type={this.props.type} data-post-id={this.props.id}>
                <div className='feed-post-body' data-recommendation-tag={content.tag} onClick={this.callRecommendation}>
                    <a href={content.url} className='feed-post-figure-link gui-image-hover gui-color-primary-link'>
                        <Video content={content} aggregated={false} />
                    </a>
                    <span className='feed-text-wrapper'>
                        <Header
                            content={content}
                            publication={this.props.publication}
                        />
                        <a href={content.url} className='feed-post-link gui-image-hover gui-color-primary-link'>
                            <span className='gui-image-hover gui-color-primary gui-color-primary-link'>
                                <p className='feed-post-body-title gui-text-title gui-color-primary'
                                    ref="title"
                                    data-video-id={content.video.id}
                                    data-short-url={content.url}
                                    data-link={content.url}>
                                        {content.title}
                                </p>
                            </span>
                        </a>
                        {aggregator}
                        <Share
                            url={content.url}
                            title={content.title}
                            imageUrl={PictureChooser.choose(content)}
                        />
                    </span>
                </div>
            </div>
        );
    }
});

module.exports = PostVideo;
